<div class="content">
  <form [formGroup]="updatePasswordForm">
    <mat-form-field class="input-form">
      <mat-label>Senha Antiga</mat-label>
      <input matInput type="password" formControlName="senhaAntiga">
    </mat-form-field>
    <mat-form-field class="input-form">
      <mat-label>Nova Senha</mat-label>
      <input matInput type="password" formControlName="senhaNova">
    </mat-form-field>
    <mat-form-field class="input-form">
      <mat-label>Verificar senha</mat-label>
      <input matInput type="password" formControlName="verificar">
    </mat-form-field>
      <button mat-raised-button
              color="primary"
              (click)="hanlderUpdatePassword()"
              [ngClass]="tema == 'ROSA' ? 'button-rosa': 'btn-success'"
              [disabled]="btnDesabilitado">Alterar</button>
  </form>
</div>
